{
  "useInheritedPermissions": "Utiliser les autorisations {{ resource }} héritées",
  "permissions": "autorisations",
  "addUserOrGroup": "Ajouter un utilisateur ou un groupe",
  "additionalPermissions": "Autorisations supplémentaires",
  "inheritedPermissions": "Autorisations héritées",
  "turnOffInheritance": "Désactiver l'héritage",
  "turnOnInheritance": "Activer l'héritage",
  "turnOnInheritanceDescription1": "En activant cette option, vous rétablirez les autorisations héritées du parent.",
  "turnOnInheritanceDescription2": "Notez qu'en réactivant cette option, toutes les autorisations supplémentaires sur cet élément seront perdues.",
  "turnOffInheritanceDescription1": "En désactivant cette option, vous pourrez ajuster les autorisations de tous les utilisateurs et groupes d'utilisateurs.",
  "turnOffInheritanceDescription2": "Notez qu'en brisant la chaîne d'héritage, aucune modification future apportée aux autorisations du parent ne sera transmise à cet élément.",
  "inheritanceChangesSaved": "Les modifications d'héritage sont automatiquement enregistrées.",
  "authLevels": {
    "admin": {
      "title": "Accès complet",
      "descriptionPlan": "Modifier l'accès, supprimer, renommer et gérer les autorisations",
      "descriptionFolder": "Créer, renommer et supprimer des plans et des dossiers",
      "descriptionLayer": "Modifier l'accès, supprimer, renommer et gérer les autorisations"
    },
    "write": {
      "title": "Modifier",
      "descriptionPlan": "Création et modification d'objets et d'attributs",
      "descriptionFolder": "Peut ajouter des plans et des sous-dossiers",
      "descriptionLayer": "Création et modification d'objets et d'attributs"
    },
    "read": {
      "title": "Afficher",
      "descriptionPlan": "Peut consulter le plan et ajouter des commentaires",
      "descriptionFolder": "Peut afficher le contenu du dossier",
      "descriptionLayer": "Peut visualiser les objets appartenant à cette couche"
    },
    "deny": {
      "title": "Pas d'accès",
      "descriptionPlan": "Impossible de voir le plan",
      "descriptionFolder": "Impossible d'afficher le contenu du dossier",
      "descriptionLayer": "Impossible de visualiser les objets appartenant à cette couche"
    }
  },
  "usersGroups": {
    "searchLabel": "Entrez un nom ou un groupe",
    "searchTitle": "Rechercher un collègue"
  },
  "permissionsEditTitle": "Définissez les autorisations de modification de {{ nodeType }}",
  "resourceLockDescription1": "Les autorisations sont verrouillées et personne ne peut apporter de modifications.",
  "resourceLockDescription2": "Les administrateurs peuvent le déverrouiller à tout moment.",
  "unlockButtonText": "Déverrouillez pour autoriser la modification",
  "inheritedLockDescription1": "Personne ne peut apporter de modifications à cause d'un verrou en cascade imposé par un parent.",
  "inheritedLockDescription2": "Les administrateurs peuvent le déverrouiller en accédant aux paramètres parents.",
  "lock": "Verrouiller",
  "inheritedPermissionsHelpText": "Lorsque ce paramètre est activé, cet objet utilisera les autorisations définies par l'objet parent.",
  "linkExpiredModal": {
    "title": "Le lien a expiré",
    "content": "Ce lien a expiré ou n'est pas valide.\n Contactez l'utilisateur qui a créé le lien si vous avez besoin d'un accès."
  },
  "copyPermissions": "Autorisations de copie"
}